<template>
  <div class="animated fadeIn">
    <b-row
      align-h="center"
      class="text-center"
    >
      <b-col md="12">
        <h4>ONLY FOR ADMIN</h4><hr>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="5">
        <b-form-group label="Auth">
          <b-form-select
            id="auth"
            v-model="auth"
            :options="authOptions"
            :disabled="!$store.getters.isRealSuper"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="LongTerm">
          <b-form-select
            id="longterm"
            v-model="longterm"
            :options="longtermOptions"
            :disabled="!$store.getters.isRealSuper"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Favorite">
          <b-form-checkbox
            id="favorite"
            v-model="favorite"
            :value="1"
            :unchecked-value="0"
            :disabled="!$store.getters.isRealSuper"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group label="SecretInfo">
          <b-form-textarea
            id="secretInfo"
            v-model="secretInfo"
            :rows="3"
            :max-rows="5"
            :disabled="!$store.getters.isRealSuper"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-button
          class="mb-5"
          variant="danger"
          size="sm"
          @click="updateAdmin()"
          :disabled="!$store.getters.isRealSuper"
        >
          SAVE
        </b-button>
      </b-col>
    </b-row>
    <b-row
      align-h="center"
      class="text-center"
    >
      <b-col md="12">
        <hr>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'RemnantAdmin',
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      auth: 0,
      authOptions: [],
      longterm: 0,
      longtermOptions: [
        { value: 0, text: '아님' },
        { value: 1, text: '장학부 추천(A)' },
        { value: 2, text: '부서 추천(A)' },
        { value: 3, text: '지정 기탁(B)' }
      ],
      secretInfo: '',
      favorite: 0
    }
  },
  mounted () {
    if (this.email !== '') {
      let authList = this.$store.state.AUTHLIST
      Object.keys(authList).forEach(name => {
        this.authOptions.push({ value: authList[name], text: name })
      })
      this.getDetailInfo(1)
    }
  },
  methods: {
    alertNotFound () {
      alert('등록된 정보가 없습니다!')
    },
    parseDetailInfo (data) {
      this.auth = data.auth
      this.longterm = data.longterm
      this.secretInfo = data.secretInfo
      this.favorite = data.favorite
    },
    alertFail (msg) {
      alert(msg)
    },
    alertSuccess () {
      alert('Update Admin Info!')
    },
    updateAdmin () {
      // post arg 세팅
      var postArg = {}
      postArg['email'] = this.email
      postArg['auth'] = this.auth
      postArg['longterm'] = this.longterm
      postArg['secretInfo'] = this.secretInfo
      postArg['favorite'] = this.favorite
      api.request('post', '/remnant/update?ic=admin', postArg)
        .then(response => {
          var data = response.data
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
            400 이면 erros.response.data.error */
          if (data.error) {
            this.alertFail(data.error)
          } else {
            this.alertSuccess()
            this.$emit('adminUpdated')
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    getDetailInfo (info) {
      if (this.errors.has('email')) {
        this.alertRetryEmail()
        return
      }
      api.request('get', '/remnant/check?' + 'email=' + this.email + '&ic=admin&info=' + info)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          if (data.check === 1 && info === 1) {
            // 로그인 후 정보수정으로 들어옴
            this.parseDetailInfo(data)
            // email잠구자
          } else {
            // insert
            // this.alertNotFound()
          }
        })
      this.$validator.reset()
    }
  }
}
</script>

<style>
</style>
